'use client'

import { useState } from 'react'
import { BiChat } from 'react-icons/bi'

import { FaqQuestion } from '@/components/FaqQuestion'
import { Seal } from '@/components/Seal'
import { FAQ } from '@/config/data'
import { useBreakpoints } from '@/hooks'

import './styles.scss'

export default function Faq() {
  const [openQuestion, setOpenQuestion] = useState<number | null>(null)
  const { isSemiMedium } = useBreakpoints()

  return (
    <section className="faq container" id="faq" aria-labelledby="faq-heading">
      <div className="faq__title">
        <div className="faq__title__content">
          <Seal
            size={isSemiMedium ? 64 : 95}
            color="var(--primary)"
            aria-hidden
          />
          <h2 id="faq-heading">
            Perguntas
            <br />
            frequentes
          </h2>

          <div className="faq__subtitle__wrapper">
            <BiChat
              size={isSemiMedium ? 24 : 32}
              color="var(--primary)"
              aria-hidden
            />
            <p>
              Ainda precisa de ajuda? <a href="#footer">Contate-nos</a>.
            </p>
          </div>
        </div>
      </div>

      <div className="faq__content">
        {FAQ.map((faq, index) => (
          <FaqQuestion
            key={index}
            questionId={`faq-pergunta-${index}`}
            question={faq.question}
            answer={faq.answer}
            isOpen={openQuestion === index}
            onClick={() => {
              if (openQuestion === index) {
                setOpenQuestion(null)
              } else {
                setOpenQuestion(index)
              }
            }}
          />
        ))}
      </div>
    </section>
  )
}
